import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { checkDoublePurchaseQueryFn } from './queries/checkDoublePurchase.query';
export const DoublePurchaseQueriesConfig = createQueriesConfig({
  checkDoublePurchase: {
    queryFn: checkDoublePurchaseQueryFn
  }
});
//# sourceMappingURL=double-purchase.config.js.map